var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/dot-notation */
import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import Tooltip from 'devextreme/ui/tooltip';
import { updateWhenLocaleChanges } from '@lit/localize';
/**
 * Represents the breadcrumb with state changes when click on an aption
 */
let DinapsisBreadcrumb = class DinapsisBreadcrumb extends LitElement {
    constructor() {
        super();
        /**
         * Sets the BreadcrumbOptions
         */
        this.options = [];
        updateWhenLocaleChanges(this);
    }
    /**
     * The createRenderRoot() function
     * is a function that is called by the LitElement base class when the
     * element is first created. It returns the element itself,
     * which means that the element will be
     * rendered in place, rather than in a shadow DOM.
     * Helps to use the css.
     * @returns The element itself.
     */
    createRenderRoot() {
        return this;
    }
    /**
     * Emit the click event.
     * @param {BreadCrumbOption} option - BreadCrumbOption -
     * option BreadCrumbOption} is passed as a event payload
     */
    emitEvent(option, index) {
        if (!option.clickable)
            return;
        this.dispatchEvent(new CustomEvent('click-option', { detail: { option, index } }));
    }
    /**
     * A lifecycle method that is called after the element has been updated.
     * return a warning if options are not set.
     */
    firstUpdated() {
        if (this.options.length <= 0) {
            // eslint-disable-next-line no-console
            console.warn('Breadcrumb options not provided');
        }
    }
    /**
     * If any property has changed when finish update this method is called an
     * depending on wich property has been modified,
     * it executes its update method
     * @param changedProperties - Map<string, unknown>
     */
    updated(changedProperties) {
        if (changedProperties.has('options')) {
            this.options.forEach((option) => {
                var _a;
                const tooltipId = `tooltip-${option.id}`;
                // Select and remove the tooltip
                const tooltipContainer = document.getElementById(tooltipId);
                if (tooltipContainer)
                    tooltipContainer.remove();
                // Select the container where the tooltip will be painted
                const breadcrumbContainer = document.getElementById(`breadcrumb-${option.id}`);
                if (!breadcrumbContainer)
                    return;
                // Create the tooltip div and set id and text
                const newTooltipContainer = document.createElement('div');
                newTooltipContainer.id = tooltipId;
                newTooltipContainer.innerHTML = (_a = option.text) !== null && _a !== void 0 ? _a : '';
                // Add to breadcrumb the tooltip container
                breadcrumbContainer.append(newTooltipContainer);
                // Check if exist container and tooltip
                if (breadcrumbContainer && newTooltipContainer) {
                    const tooltip = new Tooltip(newTooltipContainer);
                    tooltip.option('target', `#breadcrumb-text-${option.id}`);
                    tooltip.option('showEvent', 'mouseenter');
                    tooltip.option('hideEvent', 'mouseleave');
                }
            });
        }
    }
    /**
     * The function returns a string of HTML that contains a div with a span and a list of links.
     * Add a span that contains an icon. Home is a icon default
     * The list of links is generated by the function breadcrumbList().
     * @returns The return statement is returning the html template literal.
     */
    render() {
        if (this.options.length <= 0) {
            return '';
        }
        return html `
            <div class="dinapsis-breadcrumb">
              ${this.breadcrumbList()}
            </div>`;
    }
    /**
     * If the icon property is not empty, return an HTML template with an image tag. Otherwise,
     * return an HTML template with a span tag.
     * @returns The return value is a template literal.
     */
    iconBreadcrumb(option) {
        if (option.icon !== '') {
            return html `<span class="material-icons dinapsis-breadcrumb__content-wrap__icon noselect">${option.icon}</span>`;
        }
        return '';
    }
    /**
     * It returns an array of TemplateResult objects, which are created by calling the breadcrumbItem
     * function for each option in the optionList array.
     * @returns An array of TemplateResult objects.
     */
    breadcrumbList() {
        const result = this.options
            .map((option, index) => this.breadcrumbItem(option, index));
        return result;
    }
    /**
     * If the option is clickable,
     * then return a span with the class dinapsis-breadcrumb__content-wrap__item, otherwise return a
     * span with the class dinapsis-breadcrumb__content-wrap__item--disabled.
     * @param {BreadCrumbOption} option - BreadCrumbOption
     * @returns The return value is a template literal.
     */
    breadcrumbItem(option, index) {
        const className = (option.clickable) ? 'dinapsis-breadcrumb__content-wrap__item' : 'dinapsis-breadcrumb__content-wrap__item dinapsis-breadcrumb__content-wrap__item--disabled';
        return html `
        <div id='breadcrumb-${option.id}' class="dinapsis-breadcrumb__content-wrap">
          <span class="material-icons dinapsis-breadcrumb__content-wrap__icon">arrow_right</span>
          ${this.iconBreadcrumb(option)}
          <span id='breadcrumb-text-${option.id}' class="${className}" @click="${() => this.emitEvent(option, index)}">
              ${option.text}
          </span>
          <div id="tooltip-${option.id}">${option.text}</div>
        </div>
        `;
    }
};
__decorate([
    property({ type: Array() })
], DinapsisBreadcrumb.prototype, "options", void 0);
DinapsisBreadcrumb = __decorate([
    customElement('dinapsis-breadcrumb')
], DinapsisBreadcrumb);
export { DinapsisBreadcrumb };
//# sourceMappingURL=dinapsis-breadcrumb.js.map